import { deleteLiveUnitChannel } from '@api/services/cctv-camera.service';
import { useMutation } from '@tanstack/react-query';

import { toast } from 'react-toastify';

export default function useDeleteCctvCameraChannel(clientId: string, projectId: string, cctvCameraId: string) {
    const mutation = useMutation({
        mutationFn: (channelId: string) => deleteLiveUnitChannel(clientId, projectId, cctvCameraId, channelId),
        onSuccess: () => {
            toast.success('Channel deleted successfully.');
        },
        onError: (err: any) => {
            toast.error(err?.data?.message || 'Failed to delete channel. Please try again.');
        },
    });

    const remove = async (channelId: string) => {
        await mutation.mutateAsync(channelId);
    };

    return {
        remove,
        isLoading: mutation.isLoading,
    };
}
